export default __webpack_public_path__ + "static/media/insta_dexpro5.a7a0751c.png";